import { useState } from 'react';
import Link from '../link/index.js';
import type { NavItemLinkProps } from './nav-item-link-hook.js';

export const NavItemLink = (props: NavItemLinkProps) => {
  const { interpolatedHref, text, icon, rightSideItems, isActive, onClick } = props;
  const [isHovered, setIsHovered] = useState(false);

  return (
    <li
      className="list-none"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onFocus={() => setIsHovered(true)}
      onBlur={() => setIsHovered(false)}
    >
      <Link
        href={interpolatedHref}
        styled={false}
        className={`flex items-center flex-auto max-w-full after:hidden px-4 my-2 text-sm ${
          isActive ? 'text-primary visited:text-primary' : ''
        }`}
        onClick={onClick}
      >
        <div className="flex items-center w-full h-7">
          {icon}
          {text && (
            <span className="py-1 truncate flex-shrink min-w-0 ml-4" data-testid={`nav-item-${text}`}>
              {text}
            </span>
          )}
          {rightSideItems.length > 0 && (
            <div className="ml-auto flex items-center flex-shrink-0">
              {rightSideItems.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={`flex items-center ${item.alwaysVisible || isActive || isHovered ? '' : 'hidden'}`}
                  >
                    {item.element}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </Link>
    </li>
  );
};
